import React, {useEffect, useState} from 'react';
import './index.scss';
import Input from '../Input';
import Checkbox from '../Checkbox';
import CustomSelect from '../CustomSelect';
import {
  useGetPeriodsQuery,
  useCreateInspectionMutation,
  useCreateAgencyMutation,
  useUpdateAgancyMutation,
} from '../../store/builder/inspections.api';
import {toast} from 'react-toastify';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import Datepicker from '../Datepicker';
import moment from 'moment/moment';

export default function SimpleModal({
  title,
  exit,
  submitAction,
  submitTitle = '',
  children,
  isDelete = false,
}) {
  return (
    <div className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{title}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div className={`modal__content-body`}>{children}</div>
        <div className='modal__content-bottom'>
          <button className='close' onClick={exit}>
            Close
          </button>
          <button
            className={`save ${isDelete ? 'danger' : ''}`}
            onClick={submitAction}
          >
            {submitTitle}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
}
